/**
 *
 * Slider
 *
 */

import React from 'react';
import { Slider as CustomSlider } from 'antd';
import './style.less';
// import styled from 'styled-components';

function Slider({ min, max, ...rest }: any) {
  return <CustomSlider {...rest} min={min} max={max} />;
}
export default Slider;
